import { cn } from '@paladise/ui/lib/utils'
import React from 'react'

interface Prop {
  data: number | boolean | string
}

function PlanTableItem({ data }: Prop) {
  if (typeof data === 'boolean')
    return (
      <div
        className={cn(
          'size-[18px] flex-shrink-0 leading-[18px]',
          data ? 'i-ps-check text-primary-p1' : 'i-ps-back text-label-l1',
        )}
      />
    )
  return data
}

export default PlanTableItem
